// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__kvfEY","container":"Header_container__vI36D","logoContainer":"Header_logoContainer__MYmTl"};